import React from "react";

interface NavbarHeaderProps {
    logo: string;
}

const NavbarHeader: React.FC<NavbarHeaderProps> = ({ logo }) => {
    return (
        <div className="navbar-header">
            <button type="button" className="open-btn">
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
            </button>
            <a 
            className="navbar-brand" 
            href="/">
                <img style={{ display: 'flex', height: '100px', alignItems: 'center', justifyContent: 'center' }} src={logo} alt="logo"/></a>
        </div>
    )
}

export default NavbarHeader;